import { render, staticRenderFns } from "./SemifinishedproductdeliveroverviewPage.vue?vue&type=template&id=5dc5abd0"
import script from "./SemifinishedproductdeliveroverviewPage.vue?vue&type=script&lang=js"
export * from "./SemifinishedproductdeliveroverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports